import { createContext } from "react";
import { Recording } from '../../services/RecordingService';

export const ScheduleContext = createContext<Recording>({} as Recording);
